import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

export const configuratorVisible = atom<boolean>({
    key: 'configuratorVisible',
    default: true,
});

export const useConfiguratorVisibleValue = () => useRecoilValue(configuratorVisible);
export const useConfiguratorVisibleSetState = () => useSetRecoilState(configuratorVisible);
